export default "__VITE_PUBLIC_ASSET__5bee772e__"